import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import RoomsMenu from '../RoomsMenu/RoomsMenu';
import { changeIsMainMenuOpened, changeIsSummaryOpened, changeLanguage } from '../../model/configuratorSlice';
import { MainMenuButton } from '../../shared/svg/components';
import IsNullOrEmpty from '../../utils/StringUtils';
import IsNullOrUndefined from '../../utils/ObjectUtils';
import LanguageButton from '../../shared-configurator/components/LanguageButton';
import { Language } from '../../model/constants';

const SubHeader = ({ isMobilePortrait }) => {
    const {
        currentUnit, promotionSlug, currentLanguage, translations,
    } = useSelector(state => state.configurator);
    const [languageUnfolded, setLanguageUnfolded] = useState(false);
    const [otherLanguage, setOtherLanguage] = useState(Language.en);
    const dispatch = useDispatch();

    const openMenu = () => {
        dispatch(changeIsMainMenuOpened(true));
        dispatch(changeIsSummaryOpened(false));
    };

    const areTranslationsEnabled = () => !IsNullOrEmpty(translations);

    const isLanguageEnabled = (language) => {
        if (!IsNullOrEmpty(translations)) {
            const foundLanguage = translations.find(t => t.language === language);
            if (!IsNullOrUndefined(foundLanguage)) return true;
        }
        return false;
    };

    const languageSelected = (id) => {
        dispatch(changeLanguage(id));
        setLanguageUnfolded(false);

        if (id === Language.en) {
            setOtherLanguage(Language.es);
        } else {
            setOtherLanguage(Language.en);
        }
    };

    const dropdownHeaderHandler = () => {
        setLanguageUnfolded(!languageUnfolded);
    };

    return (
      <div className="subheader-container">
        <div className="container-client-promotion">
          <img
            src={`${process.env.PUBLIC_URL}/promotion/${promotionSlug}.png`}
            alt=""
          />
        </div>
        <button className="menu-button" type="button" onClick={() => openMenu()}>
          <MainMenuButton />
        </button>
        <div className={`container-logo-flat-name${areTranslationsEnabled() ? ' include-language' : ''}`}>
          {currentUnit !== null ? <div className="flat-name">{currentUnit.name}</div> : null}
        </div>

        {!isMobilePortrait ? <RoomsMenu /> : null}
        {areTranslationsEnabled() ? (
          <div className="language-container">
            <div className="dropdown-header">
              <LanguageButton
                id={currentLanguage}
                name={currentLanguage.toUpperCase()}
                onLanguageSelected={languageSelected}
              />
              <div className={`arrow${languageUnfolded ? ' unfolded' : ''}`}>
                <img
                  src={`${process.env.PUBLIC_URL}/img/arrow-languaje.svg`}
                  width="11px"
                  height="7px"
                  alt=""
                />
              </div>
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <button type="button" className="button-header" onClick={dropdownHeaderHandler} />
            </div>
            {languageUnfolded ? (
              <div className="dropdown-list">
                <>
                  {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                  <button type="button" className="blocker" onClick={() => setLanguageUnfolded(false)} />
                  <LanguageButton
                    id={otherLanguage}
                    name={otherLanguage.toUpperCase()}
                    onLanguageSelected={languageSelected}
                  />
                </>
              </div>
              ) : null}
          </div>
        ) : null}
      </div>
    );
};

SubHeader.propTypes = {
    isMobilePortrait: PropTypes.bool.isRequired,
};

export default SubHeader;
